


















import { Component, Vue } from 'vue-property-decorator';
import SpList from './components/sp-list.vue';
import Container from '@/components/v3/container.vue';
import { getMyFavoritesSpList, FavoritesSpInfo, getLatestCouponList } from './api/index';
import { to } from '@tencent/wphk-base-utils';
import { CustomException, language } from '@tencent/ppd-base-libs';
import { i18n } from '@/i18n';
import Notice from '@/components/v3/notice/index.vue';
import { NoticeItem, NoticeItemType } from '@/types/index';
import { biClick } from '@tencent/fit-bi-sdk';
import { BaseComponent } from '@tencent/wphk-components-content-loader';
import ContentLoader from './components/content-loader.vue';
import { CHANNEL_PAGE_URL } from '@/config';

@Component({
  components: {
    SpList,
    Container,
    Notice,
    ContentLoader,
    BaseComponent,
  },
})
export default class MyFavorites extends Vue {
  // 商户列表
  spList: FavoritesSpInfo[] = [];
  // 公告列表
  noticeList: NoticeItem[] = [];
  lang = language.getLanguage();
  isShow = false;
  isReady = false;
  showCom = true;
  init() {
    this.initMyFavoritesSpList();
    this.initNotice();
  }
  get showNotice() {
    return this.noticeList.length > 0;
  }
  async initMyFavoritesSpList() {
    const [err, res] = await to(getMyFavoritesSpList(0, 7));
    if (err) {
      this.showCom = false;
      throw new CustomException(err, 'getMyFavoritesSpListFail', '获取已收藏列表失败');
    }
    this.spList = res?.dataList || [];
    this.isShow = this.spList.length > 0;
    this.isReady = true;
  }
  async initNotice() {
    const [err, res] = await to(getLatestCouponList());
    if (err) {
      throw new CustomException(err, 'getLatestCouponListFail', '获取最新优惠券列表失败');
    }
    this.noticeList = (res || []).map(item => ({
      content: `{${i18n('最新優惠')}|#7D7D7D}&nbsp;&nbsp;{${item.spName}${item.couponName}|#000000}`,
      type: NoticeItemType.Coupon,
      url: `${CHANNEL_PAGE_URL}?spId=${item.spId}`,
    }));
  }
  get showMoreAll() {
    return this.spList.length >= 5;
  }
  get navText() {
    return this.showMoreAll ? i18n('全部') : '';
  }
  get navLink() {
    return this.showMoreAll ? 'https://prom.wechatpay.com.hk/discount-center/coupon_home.shtml#/weCoupons/merchantList/favorites' : '';
  }
  toMore() {
    biClick('my-favorites.tomore_click|查看全部点击');
  }
  noticeClick() {
    biClick('my-favorites.notice_click|公告点击');
  }
  created() {
    this.init();
  }
}
